// LOP Cart Drawer - Versión corregida con botones funcionando
(function() {
  'use strict';
  
  // Prevenir múltiples inicializaciones
  if (window.LOP_CART_DRAWER_INITIALIZED) {
    console.log('🚫 LOP Cart drawer ya inicializado, saltando...');
    return;
  }
  
  console.log('🚀 Iniciando LOP cart drawer - versión corregida...');
  
  // Marcar como inicializado INMEDIATAMENTE
  window.LOP_CART_DRAWER_INITIALIZED = true;
  window.DISABLE_ORIGINAL_CART_DRAWER = true;
  
  // Variables globales
  let isUpdating = false;
  let pendingUpdates = [];
  let lastUpdateTime = 0;
  const DEBOUNCE_TIME = 100; // Reducido de 300 a 100ms
  
  // EXPONER FUNCIONES GLOBALMENTE INMEDIATAMENTE
  function openCartDrawer() {
    console.log('🔄 [LOP] Abriendo cart drawer...');
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    
    const isDesktop = window.innerWidth >= 768;
    console.log(`📱 [LOP] Es desktop: ${isDesktop}`);
    
    let cartDrawer;
    if (cartDrawers.length > 1) {
      if (isDesktop) {
        cartDrawer = document.querySelector('.thb-header-horizontal-layout #Cart-Drawer') || cartDrawers[1];
      } else {
        cartDrawer = cartDrawers[0];
      }
    } else {
      cartDrawer = cartDrawers[0];
    }
    
    if (cartDrawer) {
      console.log('✅ [LOP] Cart drawer encontrado, abriendo...');
      cartDrawer.classList.add('active');
      cartDrawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      
      // FORZAR que el footer siempre esté visible - MEJORADO
      const footerContainer = cartDrawer.querySelector('.LOP-cart-drawer--footer');
      if (footerContainer) {
        footerContainer.style.display = 'block';
        footerContainer.style.visibility = 'visible';
        footerContainer.style.opacity = '1';
        footerContainer.style.height = 'auto';
        footerContainer.style.minHeight = 'auto';
        footerContainer.style.position = 'relative';
        footerContainer.style.bottom = '0';
        footerContainer.style.zIndex = '10';
      }
      
      // ACTUALIZAR mensaje de envío gratis al abrir el carrito
      setTimeout(() => {
        rebuildCartDrawerFromAPI().catch(error => {
          console.error('❌ [LOP] Error al actualizar mensaje:', error);
        });
      }, 100);
      
      // Inicializar carrusel después de abrir - dar más tiempo en mobile
      const isMobile = window.innerWidth <= 767;
      setTimeout(() => {
        console.log('🎠 [LOP] Inicializando carrusel después de abrir drawer...');
        initCartCarousel();
      }, isMobile ? 500 : 300);
      
      console.log('🎉 [LOP] Cart drawer abierto exitosamente!');
    }
  }

  function closeCartDrawer() {
    console.log('🔄 [LOP] Cerrando cart drawer...');
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    
    cartDrawers.forEach((drawer, index) => {
      console.log(`[LOP] Cerrando cart drawer ${index + 1}...`);
      drawer.classList.remove('active');
      drawer.setAttribute('inert', '');
    });
    
    document.body.style.overflow = '';
    console.log('✅ [LOP] Cart drawer cerrado!');
  }

  // EXPONER INMEDIATAMENTE
  window.LOP = window.LOP || {};
  window.LOP.openCartDrawer = openCartDrawer;
  window.LOP.closeCartDrawer = closeCartDrawer;
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  
  console.log('✅ [LOP] Funciones globales expuestas inmediatamente');
  
  // Función de verificación del sistema
  function verifySystem() {
    console.log('=== LOP CART DRAWER VERIFICACIÓN ===');
    
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    console.log(`✅ [LOP] Cart drawers encontrados: ${cartDrawers.length}`);
    
    if (cartDrawers.length === 0) {
      console.error('❌ [LOP] No se encontraron cart drawers en el DOM');
      return false;
    }
    
    console.log('=== LOP SISTEMA VERIFICADO CORRECTAMENTE ===');
    return true;
  }

  function getCartSectionsUrl() {
    const root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    const base = root.endsWith('/') ? root : `${root}/`;
    return `${base}?sections=lop-cart-drawer-items`;
  }

  function parseCartDrawerItemsHtml(sectionHtml) {
    if (!sectionHtml) return '';
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const rootEl = doc.querySelector('[data-lop-cart-items]');
    return rootEl ? rootEl.innerHTML : '';
  }

  function fetchCartDrawerItemsHtml() {
    return fetch(getCartSectionsUrl(), { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => parseCartDrawerItemsHtml(data && data['lop-cart-drawer-items']))
      .catch((error) => {
        console.warn('⚠️ [LOP] No se pudo obtener ítems Liquid del drawer:', error);
        return '';
      });
  }

  // Función MEJORADA: regenerar cart drawer manteniendo elementos originales
  function rebuildCartDrawerFromAPI() {
    console.log('🔄 [LOP] Regenerando cart drawer desde cart.js API...');
    
    // Asegurar que la configuración del tema esté disponible
    if (!window.LOP_THEME_SETTINGS) {
      initializeThemeSettings();
    }

    harvestCartDiscountBadges();
    
    return Promise.all([
      fetch('/cart.js').then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      }),
      fetchCartDrawerItemsHtml()
    ])
      .then(([cart, itemsHtml]) => {
        console.log('📦 [LOP] Cart data recibida:', cart);
        console.log(`📦 [DEBUG] Items en carrito: ${cart.items.length}`);
        console.log(`📦 [DEBUG] Total: ${cart.total_price}`);

        const generated = generateCartDrawerContent(cart);
        const contentHtml = itemsHtml || generated.content;
        
        // Actualizar todos los cart drawers
        const cartDrawers = document.querySelectorAll('#Cart-Drawer');
        
        cartDrawers.forEach((drawer, index) => {
          console.log(`[LOP] Regenerando drawer ${index + 1}...`);
          
          // Mantener estado de apertura
          const wasActive = drawer.classList.contains('active');

          // Regenerar contenido del cart drawer
          // No necesitamos guardar botones originales ya que siempre generamos nuevos con el SVG correcto
          const contentContainer = drawer.querySelector('.LOP-cart-drawer--content');
          const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
          
          if (contentContainer) {
            contentContainer.innerHTML = contentHtml;
            if (!itemsHtml) restoreCartBadgesInPlace(contentContainer);
            console.log(`✅ [LOP] Contenido regenerado para drawer ${index + 1}`);
          }
          
          if (footerContainer) {
            footerContainer.innerHTML = generated.footer;
            console.log(`✅ [LOP] Footer regenerado para drawer ${index + 1}`);
            
            // FORZAR que el footer siempre esté visible - MEJORADO
            footerContainer.style.display = 'block';
            footerContainer.style.visibility = 'visible';
            footerContainer.style.opacity = '1';
            footerContainer.style.height = 'auto';
            footerContainer.style.minHeight = 'auto';
            footerContainer.style.position = 'relative';
            footerContainer.style.bottom = '0';
            footerContainer.style.zIndex = '10';
          }
          
          // Actualizar clases del drawer
          if (cart.items.length === 0) {
            drawer.classList.add('LOP-cart-drawer--empty');
            // Asegurar que el footer esté visible incluso cuando está vacío
            if (footerContainer) {
              footerContainer.style.display = 'block';
              footerContainer.style.visibility = 'visible';
              footerContainer.style.opacity = '1';
            }
          } else {
            drawer.classList.remove('LOP-cart-drawer--empty');
          }
          
          // Restaurar estado de apertura si ya estaba abierto
          if (wasActive) {
            drawer.classList.add('active');
            drawer.removeAttribute('inert');
            document.body.style.overflow = 'hidden';
            console.log(`✅ [LOP] Estado activo restaurado para drawer ${index + 1}`);
          }
        });

        // Actualizar contador del carrito
        updateCartCounter(cart.item_count);
        
        // Reinicializar event listeners con delay para asegurar que el contenido se renderice
        setTimeout(() => {
          console.log('🔄 [LOP] Reinicializando event listeners...');
          initQuantityButtons();
          initRemoveButtons();
          initCartDrawer();
          initCartCarousel(); // Reinicializar carrusel de colección
          
          // FORZAR nuevamente la visibilidad del footer después del delay - MEJORADO
          cartDrawers.forEach(drawer => {
            const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
            if (footerContainer) {
              footerContainer.style.display = 'block';
              footerContainer.style.visibility = 'visible';
              footerContainer.style.opacity = '1';
              footerContainer.style.height = 'auto';
              footerContainer.style.minHeight = 'auto';
              footerContainer.style.position = 'relative';
              footerContainer.style.bottom = '0';
              footerContainer.style.zIndex = '10';
            }
          });
        }, 150); // Aumentado de 100 a 150ms
        
        console.log('✅ [LOP] Cart drawer regenerado completamente');

        if (!itemsHtml) {
          ensureCartDiscountBadges(cart.items).then(() => {
            cartDrawers.forEach((drawer) => restoreCartBadgesInPlace(drawer));
          });
        }

        return cart;
      })
      .catch(error => {
        console.error('❌ [LOP] Error al regenerar cart drawer:', error);
        throw error;
      });
  }

  // ================================
  // Cucardas LOP en líneas del drawer
  // /cart.js no trae metafields de colección; se cachean desde Liquid/DOM/sección
  // ================================
  function getCartBadgesMap() {
    window.LOP_CART_BADGES = window.LOP_CART_BADGES || { byId: {}, byHandle: {}, htmlById: {}, htmlByHandle: {}, missingById: {}, missingByHandle: {} };
    ['byId', 'byHandle', 'htmlById', 'htmlByHandle', 'missingById', 'missingByHandle'].forEach((key) => {
      if (!window.LOP_CART_BADGES[key]) window.LOP_CART_BADGES[key] = {};
    });
    return window.LOP_CART_BADGES;
  }

  function cacheCartDiscountBadges(productId, handle, serialized) {
    const value = String(serialized || '').trim();
    if (!value) return;
    const map = getCartBadgesMap();
    if (productId) map.byId[String(productId)] = value;
    if (handle) map.byHandle[String(handle)] = value;
  }

  function cacheCartBadgeHtml(productId, handle, html) {
    const value = String(html || '').trim();
    if (!value || !value.includes('LOP-discount-badge')) return;
    const map = getCartBadgesMap();
    if (productId) map.htmlById[String(productId)] = value;
    if (handle) map.htmlByHandle[String(handle)] = value;
  }

  function markCartBadgesMissing(productId, handle) {
    const map = getCartBadgesMap();
    if (productId) map.missingById[String(productId)] = true;
    if (handle) map.missingByHandle[String(handle)] = true;
  }

  function hasCachedCartDiscountBadges(item) {
    if (getCartBadgeHtml(item)) return true;
    const map = getCartBadgesMap();
    if (item.product_id != null && map.missingById[String(item.product_id)]) return true;
    if (item.handle && map.missingByHandle[item.handle]) return true;
    return false;
  }

  function getCartDiscountBadges(item) {
    const map = getCartBadgesMap();
    if (item.product_id != null && map.byId[String(item.product_id)]) {
      return map.byId[String(item.product_id)];
    }
    if (item.handle && map.byHandle[item.handle]) {
      return map.byHandle[item.handle];
    }
    return '';
  }

  function getCartBadgeHtml(item) {
    const map = getCartBadgesMap();
    if (item.product_id != null && map.htmlById[String(item.product_id)]) {
      return map.htmlById[String(item.product_id)];
    }
    if (item.handle && map.htmlByHandle[item.handle]) {
      return map.htmlByHandle[item.handle];
    }
    return buildCartDiscountBadgesHtml(getCartDiscountBadges(item));
  }

  function parseCartDiscountBadges(raw) {
    if (!raw || typeof raw !== 'string' || !raw.trim()) return [];
    return raw.split(';;').filter(Boolean).map((part) => {
      const segments = part.split('|');
      return {
        type: segments[0] || 'number',
        text: segments[1] || '',
        color: segments[2] || ''
      };
    }).filter((badge) => badge.text);
  }

  function escapeCartBadgeText(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildCartDiscountBadgesHtml(serialized) {
    const badges = parseCartDiscountBadges(serialized);
    if (!badges.length) return '';
    const inner = badges.map((badge) => {
      const modifier = badge.type === 'title' ? 'LOP-discount-badge--title' : 'LOP-discount-badge--number';
      const style = badge.color ? ` style="background-color: ${escapeCartBadgeText(badge.color)};"` : '';
      return `<div class="LOP-discount-badge ${modifier}"${style}><span class="LOP-discount-text">${escapeCartBadgeText(badge.text)}</span></div>`;
    }).join('');
    return `<span class="LOP-pdp-inline-discount-badges LOP-cart-item-discount-badges"><div class="LOP-discount-badges-container">${inner}</div></span>`;
  }

  function serializeBadgesFromContainer(container) {
    if (!container) return '';
    return Array.from(container.querySelectorAll('.LOP-discount-badge')).map((badge) => {
      const type = badge.classList.contains('LOP-discount-badge--title') ? 'title' : 'number';
      const text = (badge.querySelector('.LOP-discount-text') || badge).textContent.trim();
      const styleAttr = badge.getAttribute('style') || '';
      const colorMatch = styleAttr.match(/background-color:\s*([^;]+)/i);
      const color = colorMatch ? colorMatch[1].trim() : '';
      return text ? `${type}|${text}|${color}` : '';
    }).filter(Boolean).join(';;');
  }

  function harvestCartDiscountBadges() {
    document.querySelectorAll('.LOP-cart-item').forEach((el) => {
      const wrap = el.querySelector('.LOP-cart-item-discount-badges');
      const serialized = String(el.dataset.lopDiscountBadges || '').trim() || serializeBadgesFromContainer(wrap);
      if (wrap && wrap.querySelector('.LOP-discount-badge')) {
        cacheCartBadgeHtml(el.dataset.productId, el.dataset.productHandle, wrap.outerHTML);
      }
      if (serialized) {
        cacheCartDiscountBadges(el.dataset.productId, el.dataset.productHandle, serialized);
      }
    });

    document.querySelectorAll('.LOP-cart-badges-seed [data-product-id], .LOP-cart-badges-seed [data-product-handle]').forEach((el) => {
      const serialized = String(el.dataset.lopDiscountBadges || '').trim();
      if (serialized) {
        cacheCartDiscountBadges(el.dataset.productId, el.dataset.productHandle, serialized);
      }
    });

    document.querySelectorAll('[data-lop-handle][data-lop-discount-badges]').forEach((el) => {
      const serialized = String(el.dataset.lopDiscountBadges || '').trim();
      if (serialized) cacheCartDiscountBadges(null, el.dataset.lopHandle, serialized);
    });

    document.querySelectorAll('.product-card[data-product-handle], product-card[data-product-handle]').forEach((card) => {
      const handle = card.dataset.productHandle;
      if (!handle) return;
      const fromDom = serializeBadgesFromContainer(card.querySelector('.LOP-discount-badges-container'));
      if (fromDom) cacheCartDiscountBadges(null, handle, fromDom);
    });

    const pdpProductId = window.theme && window.theme.settings && window.theme.settings.product_id;
    if (pdpProductId) {
      const pdpRoot = document.querySelector('.thb-product-detail .product-price .LOP-pdp-inline-discount-badges, .product--price-container .product-price .LOP-pdp-inline-discount-badges');
      const fromPdp = serializeBadgesFromContainer(pdpRoot);
      if (fromPdp) cacheCartDiscountBadges(pdpProductId, null, fromPdp);
      if (pdpRoot && pdpRoot.outerHTML.includes('LOP-discount-badge')) {
        cacheCartBadgeHtml(pdpProductId, null, pdpRoot.outerHTML);
      }
    }
  }

  function restoreCartBadgesInPlace(root) {
    if (!root) return;
    root.querySelectorAll('.LOP-cart-item').forEach((el) => {
      if (el.querySelector('.LOP-discount-badge')) return;
      const html = getCartBadgeHtml({
        product_id: el.dataset.productId,
        handle: el.dataset.productHandle
      });
      const price = el.querySelector('.LOP-cart-item--price');
      if (html && price) price.insertAdjacentHTML('beforeend', html);
    });
  }

  function cacheBadgesFromSectionHtml(html, fallbackHandle) {
    if (!html) {
      markCartBadgesMissing(null, fallbackHandle);
      return;
    }
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[data-lop-discount-badges], .LOP-cart-item-discount-badges');
      if (!el) {
        markCartBadgesMissing(null, fallbackHandle);
        return;
      }
      const serialized = String(el.dataset.lopDiscountBadges || '').trim() || serializeBadgesFromContainer(el);
      if (serialized) {
        cacheCartDiscountBadges(el.dataset.productId, el.dataset.productHandle || fallbackHandle, serialized);
      }
      if (el.querySelector('.LOP-discount-badge')) {
        const wrap = el.classList.contains('LOP-cart-item-discount-badges')
          ? el
          : el.querySelector('.LOP-cart-item-discount-badges') || el;
        cacheCartBadgeHtml(el.dataset.productId, el.dataset.productHandle || fallbackHandle, wrap.outerHTML);
      }
      if (!serialized && !el.querySelector('.LOP-discount-badge')) {
        markCartBadgesMissing(el.dataset.productId, el.dataset.productHandle || fallbackHandle);
      }
    } catch (error) {
      // No marcar missing en error de parseo/red: reintentar en el próximo rebuild
    }
  }

  function fetchCartDiscountBadges(handle) {
    if (!handle) return Promise.resolve();
    return fetch(`/products/${encodeURIComponent(handle)}?sections=lop-cart-item-badges`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => {
        const html = data['lop-cart-item-badges'] || '';
        cacheBadgesFromSectionHtml(html, handle);
      })
      .catch(() => {});
  }

  function ensureCartDiscountBadges(items) {
    if (!items || !items.length) return Promise.resolve();
    const missing = items.filter((item) => !hasCachedCartDiscountBadges(item) && item.handle);
    if (!missing.length) return Promise.resolve();
    const uniqueHandles = Array.from(new Set(missing.map((item) => item.handle)));
    return Promise.all(uniqueHandles.map((handle) => fetchCartDiscountBadges(handle)));
  }

  // Función para generar contenido del cart drawer MEJORADA
  function generateCartDrawerContent(cart) {
    let contentHTML = '';
    let footerHTML = '';
    
    if (cart.items.length === 0) {
      contentHTML = `
        <div class="cart-empty">
          <h3>Tu carrito está vacío</h3>
          <p>Agrega algunos productos para empezar a comprar.</p>
        </div>
      `;
    } else {
      // Generar items del carrito
      cart.items.forEach((item, index) => {
        const lineNumber = index + 1;
        const itemPrice = item.final_line_price || item.line_price;
        const originalPrice = item.original_line_price || item.line_price;
        const hasDiscount = originalPrice !== itemPrice;
        const badgesSerialized = getCartDiscountBadges(item);
        const badgesHTML = getCartBadgeHtml(item);
        const productIdAttr = item.product_id ? escapeCartBadgeText(String(item.product_id)) : '';
        const handleAttr = item.handle ? escapeCartBadgeText(item.handle) : '';
        const badgesAttr = escapeCartBadgeText(badgesSerialized);
        
        // SIEMPRE generar el botón con el SVG del bote de basura
        // No reutilizar botones originales para asegurar que siempre tenga el SVG correcto
        const removeButtonHTML = `
          <button type="button" class="LOP-cart-item--remove" data-index="${lineNumber}" aria-label="Eliminar ${item.product_title}">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
              <path d="M16.25 2.16663H9.74999C8.55832 2.16663 7.58332 3.14163 7.58332 4.33329V7.04163H3.79166V8.12496H5.41666V21.6666C5.41666 22.8583 6.39166 23.8333 7.58332 23.8333H18.4167C19.6083 23.8333 20.5833 22.8583 20.5833 21.6666V8.12496H22.2083V7.04163H18.4167V4.33329C18.4167 3.14163 17.4417 2.16663 16.25 2.16663ZM8.66666 4.33329C8.66666 3.73583 9.15253 3.24996 9.74999 3.24996H16.25C16.8474 3.24996 17.3333 3.73583 17.3333 4.33329V7.04163H8.66666V4.33329ZM19.5 21.6666C19.5 22.2641 19.0141 22.75 18.4167 22.75H7.58332C6.98586 22.75 6.49999 22.2641 6.49999 21.6666V8.12496H19.5V21.6666Z" fill="black"/>
              <path d="M11.375 11.375H10.2917V18.9583H11.375V11.375Z" fill="black"/>
              <path d="M15.7083 11.375H14.625V18.9583H15.7083V11.375Z" fill="black"/>
            </svg>
          </button>
        `;
        
        contentHTML += `
          <div class="LOP-cart-item" id="CartDrawerItem-${lineNumber}" data-product-id="${productIdAttr}" data-product-handle="${handleAttr}" data-lop-discount-badges="${badgesAttr}">
            <div class="LOP-cart-item--image">
              <a href="${item.url || '#'}" title="${item.product_title}">
                ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
              </a>
            </div>
            
            <div class="LOP-cart-item--info">
              <div class="LOP-cart-item--details">
                <div class="LOP-cart-item--details-header">
                  <div class="LOP-cart-item--details-text">
                <a href="${item.url || '#'}" title="${item.product_title}" class="LOP-cart-item--title">${item.product_title}</a>
                
                    ${item.options_with_values && item.options_with_values.length > 0 ? `
                      <div class="LOP-cart-item--options">
                        ${item.options_with_values.map(opt => `
                          <span class="LOP-cart-item--option">
                            <span class="LOP-cart-item--option-label">${opt.name}:</span>
                            <span class="LOP-cart-item--option-value">${opt.value}</span>
                          </span>
                        `).join('')}
                      </div>
                    ` : (item.variant_title && item.variant_title !== 'Default Title' ? `
                  <div class="LOP-cart-item--options">${item.variant_title}</div>
                    ` : '')}
                  </div>
                </div>
                
                <div class="LOP-cart-item--price">
                  ${hasDiscount ? `<del class="LOP-cart-item--price-original">${formatMoney(originalPrice)}</del>` : ''}
                  <ins class="LOP-cart-item--price-final">${formatMoney(itemPrice)}</ins>
                  ${badgesHTML}
                </div>
              </div>
              
              <div class="LOP-cart-item--actions">
                <quantity-selector class="quantity cart-update small-qty" data-id="${item.key}">
                  <button class="minus ${item.quantity <= 1 ? 'disabled' : ''}" type="button" aria-label="Disminuir cantidad de ${item.product_title}">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                  <input
                    type="number"
                    name="updates[${item.id}]"
                    id="updates_${item.id}"
                    value="${item.quantity}"
                    min="1"
                    class="qty"
                    data-index="${lineNumber}"
                    data-id="${item.key}"
                    aria-label="Cantidad de ${item.product_title}"
                  >
                  <button class="plus" type="button" aria-label="Aumentar cantidad de ${item.product_title}">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M6 2V10M2 6H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                </quantity-selector>
              </div>
            </div>
            ${removeButtonHTML}
          </div>
        `;
      });
    }
    
    // SIEMPRE generar footer (tanto para carrito vacío como con items)
    // Obtener configuración del tema para envío gratis
    let freeShippingEnabled = false;
    let freeShippingMinimum = 250;
    
    // Intentar obtener desde la variable global
    if (window.LOP_THEME_SETTINGS) {
      freeShippingEnabled = window.LOP_THEME_SETTINGS.free_shipping || false;
      freeShippingMinimum = window.LOP_THEME_SETTINGS.free_shipping_minimum || 250;
    } else {
      // Fallback: intentar obtener desde el DOM usando data attributes
      const themeConfigElement = document.getElementById('LOP-theme-config');
      if (themeConfigElement) {
        freeShippingEnabled = themeConfigElement.dataset.freeShipping === 'true';
        freeShippingMinimum = parseFloat(themeConfigElement.dataset.freeShippingMinimum) || 250;
      } else {
        console.warn('No se encontró configuración del tema en el DOM');
      }
    }
    
    const freeShippingMinimumCents = freeShippingMinimum * 100;
    
    
    let freeShippingMessage = '';
    if (cart.items.length === 0) {
      freeShippingMessage = 'Agrega productos para ver el envío';
    } else if (freeShippingEnabled && freeShippingMinimumCents > 0) {
      if (cart.total_price >= freeShippingMinimumCents) {
        freeShippingMessage = 'Tenes envio gratis!';
      } else {
        const remaining = freeShippingMinimumCents - cart.total_price;
        freeShippingMessage = `Gasta ${formatMoney(remaining)} más para tener envio GRATIS`;
      }
    }
    
    footerHTML = `
      <div class="LOP-cart-drawer--free-shipping">
        ${freeShippingMessage}
      </div>
      
      <div class="LOP-cart-drawer--summary">
        <div class="LOP-cart-drawer--subtotal">
          <span class="LOP-cart-drawer--subtotal-label">Subtotal</span>
          <span class="LOP-cart-drawer--subtotal-amount">${formatMoney(cart.total_price)}</span>
        </div>
      </div>

      <div class="LOP-cart-drawer--buttons">
        <div class="LOP-cart-drawer--buttons-container">
          ${cart.items.length === 0 ? `
            <button type="button" class="LOP-cart-drawer--button LOP-cart-drawer--button-primary" onclick="closeCartDrawer()" title="Seguir comprando">Seguir comprando</button>
          ` : `
            <a href="/cart" class="LOP-cart-drawer--button LOP-cart-drawer--button-secondary" title="Ver carrito">Ver carrito</a>
            <form action="/cart" method="post" novalidate>
              <button type="submit" class="LOP-cart-drawer--button LOP-cart-drawer--button-primary" name="checkout" title="Finalizar compra">PAGAR</button>
            </form>
          `}
        </div>
      </div>
    `;
    
    return { content: contentHTML, footer: footerHTML };
  }

  // Función helper para formatear dinero
  function formatMoney(cents) {
    const amount = Math.round(cents / 100); // Redondear para eliminar centavos
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0 // Sin decimales
    }).format(amount);
  }

  // Función para actualizar contador del carrito
  function updateCartCounter(itemCount) {
    const cartCounts = document.querySelectorAll('.thb-secondary-area--item-count, [data-cart-count]');
    cartCounts.forEach(count => {
      count.textContent = itemCount;
    });
    console.log(`✅ [LOP] Contador actualizado: ${itemCount} items`);
  }

  // ================================
  // NUEVAS FUNCIONES CORREGIDAS
  // ================================

  // Event handler MEJORADO para quantity buttons
  function handleQuantityClick(e) {
    // Solo procesar clicks en botones de cantidad del cart drawer
    const button = e.target.closest('.quantity .plus, .quantity .minus, quantity-selector .plus, quantity-selector .minus');
    if (!button) return;
    
    // IMPORTANTE: Verificar PRIMERO si el botón está dentro de un cart drawer
    // Si NO está en un cart drawer, NO hacer nada y dejar que el handler nativo lo maneje
    const cartDrawer = button.closest('#Cart-Drawer');
    if (!cartDrawer) {
      // No está en cart drawer, dejar que el quantity-selector nativo lo maneje
      return;
    }
    
    // PREVENIR EVENTOS DUPLICADOS
    if (e.defaultPrevented) {
      console.log('⚠️ [LOP] Evento ya procesado, ignorando');
      return;
    }
    
    // Solo prevenir y detener propagación si está en cart drawer
    e.preventDefault();
    e.stopPropagation();
    
    if (button.disabled || button.classList.contains('processing')) {
      console.log('⚠️ [LOP] Botón deshabilitado o procesando, ignorando');
      return;
    }
    
    console.log(`🖱️ [DEBUG] Botón quantity clickeado:`, button);
    
    // Marcar botón como procesando INMEDIATAMENTE
    button.disabled = true;
    button.classList.add('processing');
    
    // Encontrar el input de cantidad asociado
    const quantityContainer = button.closest('quantity-selector') || button.closest('.quantity');
    const input = quantityContainer ? quantityContainer.querySelector('.qty, input[type="number"]') : null;
    
    if (!input) {
      console.error('❌ [DEBUG] No se encontró input de cantidad');
      resetButton(button);
      return;
    }
    
    console.log(`🔍 [DEBUG] Input encontrado:`, {
      name: input.name,
      value: input.value,
      id: input.id,
      dataIndex: input.dataset.index,
      dataId: input.dataset.id
    });
    
    let currentValue = parseInt(input.value) || 1;
    let newValue = currentValue;
    
    if (button.classList.contains('minus')) {
      newValue = Math.max(0, currentValue - 1);
      console.log(`➖ [DEBUG] Minus clickeado: ${currentValue} → ${newValue}`);
    } else if (button.classList.contains('plus')) {
      newValue = currentValue + 1;
      console.log(`➕ [DEBUG] Plus clickeado: ${currentValue} → ${newValue}`);
    }
    
    // Actualizar valor inmediatamente para feedback visual
    input.value = newValue;
    
    // Determinar el identificador correcto
    const identifier = getCartItemIdentifier(input, quantityContainer);
    if (!identifier) {
      console.error('❌ [DEBUG] No se pudo determinar identificador del item');
      input.value = currentValue; // Revertir cambio
      resetButton(button);
      return;
    }
    
    console.log(`📤 [DEBUG] Actualizando item con identificador: ${identifier}, cantidad: ${newValue}`);
    
    // Llamar a la función de actualización
    updateCartItemFixed(identifier, newValue, button, input, currentValue);
  }

  // Función MEJORADA para determinar el identificador del item
  function getCartItemIdentifier(input, quantityContainer) {
    console.log('🔍 [DEBUG] Determinando identificador del item...');
    
    // 1. Intentar extraer variant ID del name del input (más confiable)
    if (input.name && input.name.includes('[') && input.name.includes(']')) {
      const match = input.name.match(/updates\[(\d+)\]/);
      if (match && match[1]) {
        console.log(`✅ [DEBUG] Variant ID encontrado en name: ${match[1]}`);
        return match[1];
      }
    }
    
    // 2. Usar data-id del container quantity-selector
    if (quantityContainer && quantityContainer.dataset.id) {
      const dataId = quantityContainer.dataset.id;
      console.log(`✅ [DEBUG] Data-ID del container: ${dataId}`);
      return dataId;
    }
    
    // 3. Usar data-id del input
    if (input.dataset.id) {
      console.log(`✅ [DEBUG] Data-ID del input: ${input.dataset.id}`);
      return input.dataset.id;
    }
    
    // 4. Fallback a data-index (line number)
    if (input.dataset.index) {
      console.log(`✅ [DEBUG] Usando line index como fallback: ${input.dataset.index}`);
      return input.dataset.index;
    }
    
    console.error('❌ [DEBUG] No se pudo determinar identificador');
    return null;
  }

  // Función MEJORADA para actualizar items del carrito
  function updateCartItemFixed(identifier, quantity, button, input, originalValue) {
    console.log(`🔄 [LOP] === INICIANDO ACTUALIZACIÓN MEJORADA ===`);
    console.log(`🔄 [LOP] ID: ${identifier}, Cantidad: ${quantity}`);
    
    const now = Date.now();
    if (now - lastUpdateTime < DEBOUNCE_TIME) {
      console.log('⏳ [LOP] Ignorando actualización debido al debounce');
      resetButton(button);
      input.value = originalValue;
      return;
    }
    lastUpdateTime = now;

    if (isUpdating) {
      console.log('⏳ [LOP] Ya hay una actualización en curso, encolando...');
      pendingUpdates = [{ identifier, quantity, button, input, originalValue }];
      resetButton(button);
      input.value = originalValue;
      return;
    }

    isUpdating = true;
    document.body.classList.add('cart-updating');
    
    // Determinar si usar variant ID o line index
    let payload;
    const idString = String(identifier);
    
    // Si el ID tiene más de 8 dígitos, probablemente es un variant ID
    if (idString.length > 8 && !idString.includes(':')) {
      payload = {
        id: idString,
        quantity: parseInt(quantity)
      };
      console.log(`📤 [DEBUG] Usando variant ID payload:`, payload);
    } else if (idString.includes(':')) {
      // Es un cart key, usar line index
      const lineIndex = input.dataset.index;
      if (!lineIndex) {
        console.error('❌ [DEBUG] Cart key detectado pero no hay line index');
        resetButton(button);
        input.value = originalValue;
        isUpdating = false;
        document.body.classList.remove('cart-updating');
        return;
      }
      payload = {
        line: parseInt(lineIndex),
        quantity: parseInt(quantity)
      };
      console.log(`📤 [DEBUG] Cart key detectado, usando line index payload:`, payload);
    } else {
      // Usar como line index
      payload = {
        line: parseInt(identifier),
        quantity: parseInt(quantity)
      };
      console.log(`📤 [DEBUG] Usando line index payload:`, payload);
    }
    
    // Realizar la actualización
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log(`📡 [DEBUG] Response status: ${response.status}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      console.log('✅ [LOP] Carrito actualizado exitosamente');
      console.log('📦 [DEBUG] Nuevo estado del carrito:', {
        itemCount: cart.item_count,
        totalPrice: cart.total_price,
        itemsLength: cart.items?.length
      });
      
      // Regenerar cart drawer
      return rebuildCartDrawerFromAPI();
    })
    .catch(error => {
      console.error('❌ [LOP] Error al actualizar carrito:', error);
      
      // Revertir cambio visual en caso de error
      input.value = originalValue;
      
      // Mostrar mensaje de error al usuario
      showErrorMessage('Error al actualizar el carrito. Intenta de nuevo.');
      
      // Intentar regenerar de todas formas
      rebuildCartDrawerFromAPI();
    })
    .finally(() => {
      isUpdating = false;
      document.body.classList.remove('cart-updating');
      resetButton(button);
      
      // Procesar actualizaciones pendientes
      if (pendingUpdates.length > 0) {
        const nextUpdate = pendingUpdates.shift();
        setTimeout(() => {
          updateCartItemFixed(nextUpdate.identifier, nextUpdate.quantity, nextUpdate.button, nextUpdate.input, nextUpdate.originalValue);
        }, DEBOUNCE_TIME);
      }
      
      console.log(`🔄 [LOP] === FIN DE ACTUALIZACIÓN ===`);
    });
  }

  // Función helper para resetear estado del botón
  function resetButton(button) {
    button.disabled = false;
    button.classList.remove('processing');
  }

  // Función para mostrar errores
  function showErrorMessage(message) {
    console.error('💬 [USER ERROR]:', message);
    // Aquí puedes agregar tu lógica de UI para mostrar errores
    // Por ejemplo: toast, modal, etc.
  }

  // Función MEJORADA para inicializar botones de cantidad
  function initQuantityButtons() {
    console.log('🔧 [LOP] Inicializando botones de cantidad...');
    
    // IMPORTANTE: Remover TODOS los event listeners existentes
    document.removeEventListener('click', handleQuantityClick);
    
    // IMPORTANTE: Solo remover listeners de botones DENTRO del cart drawer
    // NO tocar los botones de la página de producto que tienen su propio handler
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    cartDrawers.forEach(drawer => {
      const drawerButtons = drawer.querySelectorAll('.quantity .plus, .quantity .minus, quantity-selector .plus, quantity-selector .minus');
      drawerButtons.forEach(button => {
        // Clonar el botón para remover listeners directos solo en el cart drawer
        button.replaceWith(button.cloneNode(true));
      });
    });
    
    // Usar SOLO event delegation
    document.addEventListener('click', handleQuantityClick);
    
    console.log('✅ [LOP] Event delegation configurado para quantity buttons (sin duplicados)');
  }

  // Función MEJORADA para inicializar botones de eliminar
  function initRemoveButtons() {
    console.log('🔧 [LOP] Inicializando botones de eliminar...');
    
    // Remover listener existente si existe
    document.removeEventListener('click', handleRemoveClick);
    
    // Usar event delegation
    document.addEventListener('click', handleRemoveClick);
    
    console.log('✅ [LOP] Event delegation configurado para remove buttons');
  }

  // Event handler para botones de eliminar
  function handleRemoveClick(e) {
    const button = e.target.closest('.LOP-cart-item--remove');
    if (!button) return;
    
    // Verificar que esté en un cart drawer
    const cartDrawer = button.closest('#Cart-Drawer');
    if (!cartDrawer) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    if (button.disabled) return;
    
    console.log(`🗑️ [DEBUG] Botón eliminar clickeado:`, button);
    
    button.disabled = true;
    
    // Encontrar el item del carrito
    const cartItem = button.closest('.LOP-cart-item');
    if (!cartItem) {
      console.error('❌ [DEBUG] No se encontró cart item');
      button.disabled = false;
      return;
    }
    
    // Encontrar el input de cantidad
    const input = cartItem.querySelector('.qty, input[type="number"]');
    if (!input) {
      console.error('❌ [DEBUG] No se encontró input en item a eliminar');
      button.disabled = false;
      return;
    }
    
    cartItem.style.opacity = "0.5";
    
    // Usar data-index del botón o del input
    let identifier = button.dataset.index || input.dataset.index;
    
    // Si no hay data-index, intentar extraer del name
    if (!identifier && input.name) {
      const match = input.name.match(/updates\[(\d+)\]/);
      if (match && match[1]) {
        identifier = match[1];
      }
    }
    
    if (!identifier) {
      console.error('❌ [DEBUG] No se pudo determinar identificador para eliminar');
      button.disabled = false;
      cartItem.style.opacity = "";
      return;
    }
    
    console.log(`📤 [DEBUG] Eliminando item con identificador: ${identifier}`);
    updateCartItemFixed(identifier, 0, button, input, parseInt(input.value) || 1);
  }

  // Función para debuggear el sistema de cantidades
  function debugQuantitySystem() {
    console.log('=== DEBUG QUANTITY SYSTEM ===');
    
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    console.log(`📊 Cart drawers encontrados: ${cartDrawers.length}`);
    
    cartDrawers.forEach((drawer, drawerIndex) => {
      const isActive = drawer.classList.contains('active');
      console.log(`📦 Drawer ${drawerIndex + 1} (active: ${isActive}):`);
      
      const quantityContainers = drawer.querySelectorAll('quantity-selector, .quantity');
      console.log(`  📊 Quantity containers: ${quantityContainers.length}`);
      
      quantityContainers.forEach((container, index) => {
        const input = container.querySelector('.qty, input[type="number"]');
        const plusBtn = container.querySelector('.plus');
        const minusBtn = container.querySelector('.minus');
        
        console.log(`  📦 Container ${index + 1}:`, {
          containerDataId: container.dataset.id,
          inputName: input?.name,
          inputValue: input?.value,
          inputDataIndex: input?.dataset.index,
          inputDataId: input?.dataset.id,
          hasPlusBtn: !!plusBtn,
          hasMinusBtn: !!minusBtn,
          plusDisabled: plusBtn?.disabled,
          minusDisabled: minusBtn?.disabled
        });
      });
    });
  }

  // Función para debuggear event listeners
  function debugEventListeners() {
    console.log('=== DEBUG EVENT LISTENERS ===');
    
    const buttons = document.querySelectorAll('.quantity .plus, .quantity .minus');
    buttons.forEach((button, index) => {
      console.log(`Botón ${index + 1}:`, {
        element: button,
        disabled: button.disabled,
        processing: button.classList.contains('processing'),
        parentContainer: button.closest('quantity-selector')?.dataset.id || 'N/A'
      });
    });
  }

  // Resto de funciones sin cambios...
  function initCartDrawer() {
    console.log('🔧 [LOP] Inicializando cart drawer...');
    
    const cartToggle = document.querySelectorAll('#cart-drawer-toggle, [data-cart-drawer-toggle]');
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    
    cartToggle.forEach(toggle => {
      if (toggle) {
        const newToggle = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(newToggle, toggle);
        
        newToggle.addEventListener('click', function(e) {
          e.preventDefault();
          openCartDrawer();
        });
      }
    });

    cartDrawers.forEach(cartDrawer => {
      const closeButton = cartDrawer.querySelector('.LOP-cart-drawer--close');
      const overlay = cartDrawer.querySelector('.LOP-cart-drawer--overlay');
      
      if (closeButton) {
        const newCloseButton = closeButton.cloneNode(true);
        closeButton.parentNode.replaceChild(newCloseButton, closeButton);
        newCloseButton.addEventListener('click', closeCartDrawer);
      }
      
      if (overlay) {
        const newOverlay = overlay.cloneNode(true);
        overlay.parentNode.replaceChild(newOverlay, overlay);
        newOverlay.addEventListener('click', closeCartDrawer);
      }
    });
  }

  function listenForAddToCartDelegated() {
    console.log('🔧 [LOP] Configurando listener para formularios de add to cart...');
    
    document.body.addEventListener('submit', function (e) {
      const form = e.target;
      
      // NO interceptar formularios de producto que ya tienen su propio handler
      // Verificar si el formulario está dentro de un product-form no sticky
      const productFormElement = form.closest('product-form');
      if (productFormElement && !productFormElement.dataset.sticky) {
        // Este formulario ya tiene su handler nativo en product.js, no interceptarlo
        console.log('📝 [LOP] Formulario de producto detectado, dejando que el handler nativo lo maneje');
        return;
      }
      
      // Solo interceptar formularios que no tienen handler nativo
      if (form.matches('form[action^="/cart/add"]')) {
        e.preventDefault();
        e.stopPropagation(); // IMPORTANTE: detener la propagación
        const formData = new FormData(form);

        console.log('📝 [LOP] Formulario de producto interceptado');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          console.log(`📡 [DEBUG] Add to cart response status: ${response.status}`);
          return response.json();
        })
        .then(data => {
          console.log('✅ [LOP] Producto agregado (form):', data);
          return rebuildCartDrawerFromAPI();
        })
        .then(() => {
          // SIEMPRE abrir el cart drawer después de agregar producto
          setTimeout(() => {
            openCartDrawer();
            
            // FORZAR nuevamente la visibilidad del footer después de abrir - MEJORADO
            setTimeout(() => {
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                if (footerContainer) {
                  footerContainer.style.display = 'block';
                  footerContainer.style.visibility = 'visible';
                  footerContainer.style.opacity = '1';
                  footerContainer.style.height = 'auto';
                  footerContainer.style.minHeight = 'auto';
                  footerContainer.style.position = 'relative';
                  footerContainer.style.bottom = '0';
                  footerContainer.style.zIndex = '10';
                }
              });
            }, 100);
            
            // VERIFICACIÓN ADICIONAL ESPECÍFICA PARA PRIMER ITEM
            setTimeout(() => {
              console.log('🔄 [LOP] Verificación adicional para primer item...');
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                const contentContainer = drawer.querySelector('.LOP-cart-drawer--content');
                
                if (footerContainer && contentContainer) {
                  // Verificar si hay items en el contenido
                  const hasItems = contentContainer.querySelector('.LOP-cart-item');
                  
                  if (hasItems) {
                    console.log('✅ [LOP] Items detectados, asegurando footer visible...');
                    // Forzar visibilidad del footer cuando hay items
                    footerContainer.style.display = 'block';
                    footerContainer.style.visibility = 'visible';
                    footerContainer.style.opacity = '1';
                    footerContainer.style.height = 'auto';
                    footerContainer.style.minHeight = 'auto';
                    footerContainer.style.position = 'relative';
                    footerContainer.style.bottom = '0';
                    footerContainer.style.zIndex = '10';
                    
                    // También asegurar que el drawer no tenga la clase empty
                    drawer.classList.remove('LOP-cart-drawer--empty');
                  }
                }
              });
            }, 300); // Delay adicional para asegurar que el contenido se haya renderizado
          }, 200);
        })
        .catch(error => {
          console.error('❌ [LOP] Error al agregar producto:', error);
        });
      }
    });
  }

  function listenForAddToCartButtons() {
    console.log('🔧 [LOP] Configurando listener para botones de add to cart...');
    
    let isAddingToCart = false;
    
    document.body.addEventListener('click', function (e) {
      const button = e.target.closest('[data-product-id]');
      if (button && button.matches('.product-card--add-to-cart-button') && !isAddingToCart) {
        e.preventDefault();
        const variantId = button.getAttribute('data-product-id');
        if (!variantId) return;

        isAddingToCart = true;
        button.disabled = true;

        console.log('📝 [LOP] Botón add to cart clickeado');

        const payload = { id: variantId, quantity: 1 };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(res => {
          console.log(`📡 [DEBUG] Add to cart button response status: ${res.status}`);
          return res.json();
        })
        .then(data => {
          console.log('✅ [LOP] Producto agregado (botón suelto):', data);
          return rebuildCartDrawerFromAPI();
        })
        .then(() => {
          // SIEMPRE abrir el cart drawer después de agregar producto
          setTimeout(() => {
            openCartDrawer();
            
            // FORZAR nuevamente la visibilidad del footer después de abrir - MEJORADO
            setTimeout(() => {
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                if (footerContainer) {
                  footerContainer.style.display = 'block';
                  footerContainer.style.visibility = 'visible';
                  footerContainer.style.opacity = '1';
                  footerContainer.style.height = 'auto';
                  footerContainer.style.minHeight = 'auto';
                  footerContainer.style.position = 'relative';
                  footerContainer.style.bottom = '0';
                  footerContainer.style.zIndex = '10';
                }
              });
            }, 100);
            
            // VERIFICACIÓN ADICIONAL ESPECÍFICA PARA PRIMER ITEM
            setTimeout(() => {
              console.log('🔄 [LOP] Verificación adicional para primer item...');
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                const contentContainer = drawer.querySelector('.LOP-cart-drawer--content');
                
                if (footerContainer && contentContainer) {
                  // Verificar si hay items en el contenido
                  const hasItems = contentContainer.querySelector('.LOP-cart-item');
                  
                  if (hasItems) {
                    console.log('✅ [LOP] Items detectados, asegurando footer visible...');
                    // Forzar visibilidad del footer cuando hay items
                    footerContainer.style.display = 'block';
                    footerContainer.style.visibility = 'visible';
                    footerContainer.style.opacity = '1';
                    footerContainer.style.height = 'auto';
                    footerContainer.style.minHeight = 'auto';
                    footerContainer.style.position = 'relative';
                    footerContainer.style.bottom = '0';
                    footerContainer.style.zIndex = '10';
                    
                    // También asegurar que el drawer no tenga la clase empty
                    drawer.classList.remove('LOP-cart-drawer--empty');
                  }
                }
              });
            }, 300); // Delay adicional para asegurar que el contenido se haya renderizado
          }, 200);
        })
        .catch(err => {
          console.error('❌ [LOP] Error al agregar:', err);
        })
        .finally(() => {
          isAddingToCart = false;
          button.disabled = false;
        });
      }
    });
  }

  // Función para inicializar configuración del tema
  function initializeThemeSettings() {
    console.log('🔧 [LOP] Inicializando configuración del tema...');
    
    // Intentar obtener desde data attributes si no está en window
    if (!window.LOP_THEME_SETTINGS) {
      const themeConfigElement = document.getElementById('LOP-theme-config');
      if (themeConfigElement) {
        window.LOP_THEME_SETTINGS = {
          free_shipping: themeConfigElement.dataset.freeShipping === 'true',
          free_shipping_minimum: parseFloat(themeConfigElement.dataset.freeShippingMinimum) || 250
        };
      } else {
        console.warn('⚠️ [LOP] No se encontró configuración del tema');
        window.LOP_THEME_SETTINGS = {
          free_shipping: false,
          free_shipping_minimum: 250
        };
      }
    }
  }

  // Función para escuchar eventos de productos agregados al carrito
  function listenForCartItemAdded() {
    console.log('🔧 [LOP] Configurando listener para cart:item-added...');
    
    // Usar capture phase para asegurar que capturamos el evento
    document.addEventListener('cart:item-added', function(e) {
      console.log('📦 [LOP] Evento cart:item-added recibido, actualizando cart drawer...', e);
      
      // Actualizar el cart drawer desde la API
      rebuildCartDrawerFromAPI()
        .then(() => {
          console.log('✅ [LOP] Cart drawer actualizado, abriendo...');
          // Abrir el cart drawer después de actualizar
          setTimeout(() => {
            openCartDrawer();
            
            // FORZAR visibilidad del footer después de abrir
            setTimeout(() => {
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                if (footerContainer) {
                  footerContainer.style.display = 'block';
                  footerContainer.style.visibility = 'visible';
                  footerContainer.style.opacity = '1';
                  footerContainer.style.height = 'auto';
                  footerContainer.style.minHeight = 'auto';
                  footerContainer.style.position = 'relative';
                  footerContainer.style.bottom = '0';
                  footerContainer.style.zIndex = '10';
                }
              });
            }, 100);
          }, 200);
        })
        .catch(error => {
          console.error('❌ [LOP] Error al actualizar cart drawer:', error);
          // Intentar abrir de todas formas
          setTimeout(() => {
            openCartDrawer();
          }, 200);
        });
    }, true); // Usar capture phase
    
    // Interceptar cuando se llama a cartDrawer.open() desde product.js
    // Usar un intervalo para verificar periódicamente si hay cart drawers y sobrescribir su método open
    function interceptCartDrawerOpen() {
      const originalCartDrawers = document.querySelectorAll('cart-drawer, #Cart-Drawer');
      originalCartDrawers.forEach(drawer => {
        // Verificar si ya fue interceptado
        if (drawer.dataset.lopIntercepted === 'true') {
          return;
        }
        
        drawer.dataset.lopIntercepted = 'true';
        
        // Si es un elemento cart-drawer, interceptar su método open
        if (drawer.tagName === 'CART-DRAWER' && typeof drawer.open === 'function') {
          const originalOpen = drawer.open.bind(drawer);
          drawer.open = function() {
            console.log('🔄 [LOP] Interceptando cartDrawer.open(), actualizando y abriendo LOP cart drawer...');
            // Actualizar y abrir el cart drawer LOP
            rebuildCartDrawerFromAPI()
              .then(() => {
                setTimeout(() => {
                  openCartDrawer();
                }, 200);
              })
              .catch(error => {
                console.error('❌ [LOP] Error al actualizar cart drawer:', error);
                setTimeout(() => {
                  openCartDrawer();
                }, 200);
              });
          };
        }
      });
    }
    
    // Ejecutar inmediatamente
    interceptCartDrawerOpen();
    
    // También ejecutar después de un delay para capturar cart drawers que se creen dinámicamente
    setTimeout(interceptCartDrawerOpen, 500);
    setTimeout(interceptCartDrawerOpen, 1000);
    
    // También observar cambios en el DOM para detectar cuando se actualiza el cart drawer
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Verificar si se agregó contenido al cart drawer
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.id === 'Cart-Drawer' || node.querySelector && node.querySelector('#Cart-Drawer'))) {
              console.log('🔄 [LOP] Cart drawer actualizado en DOM, verificando si necesita abrirse...');
            }
          });
        }
      });
    });
    
    // Observar cambios en el body para detectar actualizaciones del cart drawer
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    
    console.log('✅ [LOP] Listener para cart:item-added configurado');
  }

  // ================================================
  // CARRUSEL DE COLECCIÓN EN CART DRAWER
  // ================================================
  
  // Variables globales para el carrusel
  let carouselCurrentIndex = 0;
  let carouselItemsPerView = 2;
  let carouselTotalItems = 0;
  let carouselItemWidth = 0; // Se calcula dinámicamente
  let carouselGap = 12;
  let carouselListenerAdded = false;
  let carouselDragBound = false;
  let cancelCarouselSettle = function() {};
  
  // Función para actualizar el estado de los botones del carrusel
  function updateCarouselButtons() {
    const activeDrawer = document.querySelector('#Cart-Drawer.active') || document.querySelector('#Cart-Drawer');
    if (!activeDrawer) return;
    
    const container = activeDrawer.querySelector('.LOP-cart-drawer--carousel-container');
    const prevBtn = activeDrawer.querySelector('.LOP-cart-drawer--carousel-prev');
    const nextBtn = activeDrawer.querySelector('.LOP-cart-drawer--carousel-next');
    
    if (!container) return;
    
    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;
    
    const canGoPrev = scrollLeft > 5; // Pequeño margen para imprecisiones
    const canGoNext = scrollLeft < maxScroll - 5;
    
    if (prevBtn) {
      prevBtn.disabled = !canGoPrev;
      prevBtn.style.opacity = canGoPrev ? '1' : '0.4';
    }
    if (nextBtn) {
      nextBtn.disabled = !canGoNext;
      nextBtn.style.opacity = canGoNext ? '1' : '0.4';
    }
    
    console.log(`🔄 [LOP] Carrusel - ScrollLeft: ${Math.round(scrollLeft)}, MaxScroll: ${Math.round(maxScroll)}, Prev: ${canGoPrev}, Next: ${canGoNext}`);
  }
  
  // Función para actualizar la posición del carrusel (compatibilidad)
  function updateCarouselPosition() {
    updateCarouselButtons();
  }
  
  // Función para ir al slide anterior
  function carouselGoPrev() {
    cancelCarouselSettle();
    console.log('⬅️ [LOP] Click en botón ANTERIOR');
    const activeDrawer = document.querySelector('#Cart-Drawer.active') || document.querySelector('#Cart-Drawer');
    if (!activeDrawer) return;
    
    const container = activeDrawer.querySelector('.LOP-cart-drawer--carousel-container');
    const items = activeDrawer.querySelectorAll('.LOP-cart-drawer--carousel-item');
    if (!container || items.length === 0) return;
    
    const isMobile = window.innerWidth <= 767;
    const itemsPerPage = isMobile ? 2 : 3;
    const firstItem = items[0];
    const itemWidth = firstItem ? (firstItem.offsetWidth || 160) : 160;
    const scrollAmount = itemsPerPage * (itemWidth + carouselGap);
    
    container.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
    
    setTimeout(updateCarouselButtons, 350);
  }
  
  // Función para ir al slide siguiente
  function carouselGoNext() {
    cancelCarouselSettle();
    console.log('➡️ [LOP] Click en botón SIGUIENTE');
    const activeDrawer = document.querySelector('#Cart-Drawer.active') || document.querySelector('#Cart-Drawer');
    if (!activeDrawer) return;
    
    const container = activeDrawer.querySelector('.LOP-cart-drawer--carousel-container');
    const items = activeDrawer.querySelectorAll('.LOP-cart-drawer--carousel-item');
    if (!container || items.length === 0) return;
    
    const isMobile = window.innerWidth <= 767;
    const itemsPerPage = isMobile ? 2 : 3;
    const firstItem = items[0];
    const itemWidth = firstItem ? (firstItem.offsetWidth || 160) : 160;
    const scrollAmount = itemsPerPage * (itemWidth + carouselGap);
    
    container.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
    
    setTimeout(updateCarouselButtons, 350);
  }
  
  // El carrusel dinámico se llena después del primer init (recomendaciones).
  // Los listeners van por delegación y tienen que existir aunque todavía no haya cards.
  function bindCarouselDrag() {
    if (carouselDragBound) return;
    carouselDragBound = true;

    let isDragging = false;
    let dragMoved = false;
    let suppressCarouselClick = false;
    let dragStartX = 0;
    let dragScrollLeft = 0;
    let dragContainer = null;
    let lastMoveX = 0;
    let lastMoveTime = 0;
    let dragVelocity = 0;
    let settleFrame = 0;
    const dragThreshold = 6;

    function cancelSettle() {
      if (!settleFrame) return;
      cancelAnimationFrame(settleFrame);
      settleFrame = 0;
    }
    cancelCarouselSettle = cancelSettle;

    function startDrag(e) {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      if (isDragging) return;
      const container = e.target.closest && e.target.closest('.LOP-cart-drawer--carousel-container');
      if (!container) return;
      if (e.target.closest('button, select, label')) return;

      const link = e.target.closest('a');
      if (link) link.draggable = false;
      container.querySelectorAll('img').forEach(function(img) { img.draggable = false; });

      cancelSettle();
      isDragging = true;
      dragMoved = false;
      dragVelocity = 0;
      dragContainer = container;
      dragStartX = e.pageX;
      dragScrollLeft = container.scrollLeft;
      lastMoveX = e.pageX;
      lastMoveTime = performance.now();
    }

    function moveDrag(e) {
      if (!isDragging || !dragContainer) return;
      const delta = e.pageX - dragStartX;
      if (!dragMoved && Math.abs(delta) < dragThreshold) return;

      if (!dragMoved) {
        dragMoved = true;
        dragContainer.classList.add('is-dragging');
      }
      e.preventDefault();

      const now = performance.now();
      const dt = now - lastMoveTime;
      if (dt >= 16) {
        dragVelocity = (lastMoveX - e.pageX) / dt;
        lastMoveX = e.pageX;
        lastMoveTime = now;
      }
      dragContainer.scrollLeft = dragScrollLeft - delta;
    }

    function settleCarousel(container, velocity) {
      const items = container.querySelectorAll('.LOP-cart-drawer--carousel-item');
      if (!items.length) return;

      const origin = items[0].offsetLeft;
      const points = [];
      for (let i = 0; i < items.length; i++) {
        points.push(items[i].offsetLeft - origin);
      }
      const step = points.length > 1 ? Math.max(1, points[1] - points[0]) : items[0].offsetWidth;
      const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      const coast = Math.max(-step * 0.85, Math.min(step * 0.85, velocity * 240));
      const projected = Math.max(0, Math.min(maxScroll, container.scrollLeft + coast));
      const raw = projected / step;
      const frac = raw - Math.floor(raw);
      let index = Math.round(raw);

      if (coast > 8 && frac > 0.22) index = Math.ceil(raw);
      if (coast < -8 && frac > 0 && frac < 0.78) index = Math.floor(raw);
      index = Math.max(0, Math.min(points.length - 1, index));

      let target = points[index];
      if (target > maxScroll - 1) target = maxScroll;
      target = Math.max(0, Math.min(maxScroll, target));

      const from = container.scrollLeft;
      if (Math.abs(target - from) < 1) {
        updateCarouselButtons();
        return;
      }

      const duration = Math.max(240, Math.min(460, 200 + Math.abs(target - from) * 0.5));
      const start = performance.now();

      function frame(now) {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        container.scrollLeft = from + (target - from) * eased;
        if (t < 1) {
          settleFrame = requestAnimationFrame(frame);
        } else {
          settleFrame = 0;
          container.scrollLeft = target;
          updateCarouselButtons();
        }
      }
      settleFrame = requestAnimationFrame(frame);
    }

    function endDrag() {
      if (!isDragging) return;
      const container = dragContainer;
      const moved = dragMoved;
      const velocity = (performance.now() - lastMoveTime > 90) ? 0 : dragVelocity;
      if (moved) suppressCarouselClick = true;
      isDragging = false;
      dragMoved = false;
      dragVelocity = 0;
      if (container) {
        container.classList.remove('is-dragging');
        if (moved) settleCarousel(container, velocity);
        else updateCarouselButtons();
      }
      dragContainer = null;
    }

    document.addEventListener('pointerdown', startDrag);
    document.addEventListener('mousedown', startDrag);
    document.addEventListener('pointermove', moveDrag, { passive: false });
    document.addEventListener('mousemove', moveDrag, { passive: false });
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('pointercancel', endDrag);
    document.addEventListener('dragend', endDrag);

    // Chrome convierte el arrastre de un link o una imagen en drag nativo:
    // deja de emitir mousemove y cambia el cursor. Hay que cancelarlo.
    document.addEventListener('dragstart', function(e) {
      const container = e.target.closest && e.target.closest('.LOP-cart-drawer--carousel-container');
      if (!container || e.target.closest('button, select, label')) return;
      e.preventDefault();
      if (!isDragging) startDrag(e);
    }, true);

    document.addEventListener('drag', function(e) {
      if (!e.clientX && !e.pageX) return;
      moveDrag(e);
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest && e.target.closest('.LOP-cart-drawer--carousel-prev, .LOP-cart-drawer--carousel-next')) {
        cancelSettle();
      }
    }, true);

    document.addEventListener('click', function(e) {
      if (!suppressCarouselClick) return;
      suppressCarouselClick = false;
      if (!e.target.closest('.LOP-cart-drawer--carousel-container')) return;
      if (e.target.closest('button, select, label')) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  // Función para inicializar el carrusel de colección
  function initCartCarousel() {
    bindCarouselDrag();
    console.log('🎠 [LOP] Inicializando carrusel de colección...');
    
    const carouselSection = document.querySelector('#Cart-Drawer.active .LOP-cart-drawer--carousel-section')
      || document.querySelector('.LOP-cart-drawer--carousel-section');
    if (!carouselSection) {
      console.log('ℹ️ [LOP] No se encontró sección de carrusel');
      return;
    }
    
    const track = carouselSection.querySelector('.LOP-cart-drawer--carousel-track');
    const items = carouselSection.querySelectorAll('.LOP-cart-drawer--carousel-item');
    const container = carouselSection.querySelector('.LOP-cart-drawer--carousel-container');
    
    if (!track || items.length === 0) {
      console.log('ℹ️ [LOP] No hay items en el carrusel');
      return;
    }
    
    carouselTotalItems = items.length;
    carouselCurrentIndex = 0;
    
    // Determinar items por vista según el tamaño de pantalla
    const isMobile = window.innerWidth <= 767;
    carouselItemsPerView = isMobile ? 2.5 : 3;
    
    // Resetear posición de scroll al inicio
    if (container) {
      container.scrollLeft = 0;
    }
    
    console.log(`📊 [LOP] Items totales: ${carouselTotalItems}, Items por vista: ${carouselItemsPerView}, Mobile: ${isMobile}`);
    
    // Inicializar estado de botones después de un breve delay
    setTimeout(updateCarouselButtons, 150);
    
    // Agregar event listener con delegation solo una vez
    if (!carouselListenerAdded) {
      document.addEventListener('click', function(e) {
        const prevBtn = e.target.closest('.LOP-cart-drawer--carousel-prev');
        const nextBtn = e.target.closest('.LOP-cart-drawer--carousel-next');
        
        if (prevBtn) {
          e.preventDefault();
          e.stopPropagation();
          carouselGoPrev();
        }
        
        if (nextBtn) {
          e.preventDefault();
          e.stopPropagation();
          carouselGoNext();
        }
      });
      
      // Resize listener con debounce
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          const isMobile = window.innerWidth <= 767;
          carouselItemsPerView = isMobile ? 2.5 : 3;
          updateCarouselButtons();
        }, 150);
      });
      
      // Scroll listener usando delegation
      document.addEventListener('scroll', function(e) {
        if (e.target.classList && e.target.classList.contains('LOP-cart-drawer--carousel-container')) {
          updateCarouselButtons();
        }
      }, true);
      
      carouselListenerAdded = true;
      console.log('✅ [LOP] Event listeners del carrusel agregados');
    }
    
    console.log(`✅ [LOP] Carrusel inicializado con ${carouselTotalItems} items`);
  }
  
  let sizePanel = null;
  let sizePanelSelect = null;

  function isMobileSizePicker() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function closeSizePanel() {
    if (sizePanelSelect) sizePanelSelect.classList.remove('is-open');
    sizePanelSelect = null;
    if (sizePanel) sizePanel.hidden = true;
  }

  function positionSizePanel(select) {
    const rect = select.getBoundingClientRect();
    const gap = 4;
    const margin = 8;
    sizePanel.style.width = Math.round(rect.width) + 'px';
    sizePanel.style.maxHeight = '220px';
    sizePanel.hidden = false;
    const spaceBelow = window.innerHeight - rect.bottom - margin;
    const spaceAbove = rect.top - margin;
    const openUp = spaceBelow < 120 && spaceAbove > spaceBelow;
    const available = Math.max(72, (openUp ? spaceAbove : spaceBelow) - gap);
    sizePanel.style.maxHeight = Math.min(220, available) + 'px';
    const top = openUp ? rect.top - sizePanel.offsetHeight - gap : rect.bottom + gap;
    sizePanel.style.left = Math.round(rect.left) + 'px';
    sizePanel.style.top = Math.round(Math.max(margin, Math.min(top, window.innerHeight - sizePanel.offsetHeight - margin))) + 'px';
  }

  function openSizePanel(select) {
    if (!sizePanel) {
      sizePanel = document.createElement('div');
      sizePanel.className = 'LOP-cart-drawer--size-panel';
      sizePanel.setAttribute('role', 'listbox');
      sizePanel.setAttribute('aria-label', 'Talle');
      sizePanel.hidden = true;
      document.body.appendChild(sizePanel);
    }
    if (sizePanelSelect && sizePanelSelect !== select) sizePanelSelect.classList.remove('is-open');
    sizePanelSelect = select;
    select.classList.add('is-open');
    const current = select.value;
    sizePanel.replaceChildren();
    Array.prototype.forEach.call(select.options, function(option) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'LOP-cart-drawer--size-panel-option';
      button.setAttribute('role', 'option');
      button.dataset.value = option.value;
      button.textContent = option.textContent.trim();
      if (option.value === current) {
        button.classList.add('is-selected');
        button.setAttribute('aria-selected', 'true');
      } else {
        button.setAttribute('aria-selected', 'false');
      }
      sizePanel.appendChild(button);
    });
    positionSizePanel(select);
    const selected = sizePanel.querySelector('.is-selected');
    if (selected && selected.scrollIntoView) selected.scrollIntoView({ block: 'nearest' });
  }

  function bindMobileSizePanel() {
    document.addEventListener('pointerdown', function(e) {
      if (!isMobileSizePicker()) return;
      const select = e.target.closest && e.target.closest('select[data-lop-cart-rec-size]');
      if (select) {
        e.preventDefault();
        e.stopPropagation();
        if (sizePanelSelect === select && sizePanel && !sizePanel.hidden) closeSizePanel();
        else openSizePanel(select);
        return;
      }
      if (!sizePanel || sizePanel.hidden) return;
      if (e.target.closest && e.target.closest('.LOP-cart-drawer--size-panel')) return;
      closeSizePanel();
    }, true);

    document.addEventListener('click', function(e) {
      const optionBtn = e.target.closest && e.target.closest('.LOP-cart-drawer--size-panel-option');
      if (!optionBtn || !sizePanelSelect) return;
      e.preventDefault();
      e.stopPropagation();
      sizePanelSelect.value = optionBtn.dataset.value;
      sizePanelSelect.dispatchEvent(new Event('change', { bubbles: true }));
      closeSizePanel();
    });

    document.addEventListener('scroll', function(e) {
      if (!sizePanel || sizePanel.hidden) return;
      if (e.target && e.target.closest && e.target.closest('.LOP-cart-drawer--size-panel')) return;
      closeSizePanel();
    }, true);

    window.addEventListener('resize', closeSizePanel);
  }

  function syncCarouselSize(select) {
    const item = select.closest('.LOP-cart-drawer--carousel-item');
    if (!item) return;
    const button = item.querySelector('.LOP-cart-drawer--carousel-add-btn');
    const option = select.selectedOptions && select.selectedOptions[0];
    if (!button || !option) return;

    button.dataset.productId = option.value;
    const available = option.getAttribute('data-available') !== 'false';
    button.disabled = !available;
    const label = button.querySelector('.LOP-cart-drawer--carousel-add-btn-text');
    if (!label) return;
    if (!available) {
      label.textContent = 'Agotado';
    } else if (label.textContent === 'Agotado' && button.dataset.defaultLabel) {
      label.textContent = button.dataset.defaultLabel;
    }
  }

  // Función para manejar clicks en botones de agregar al carrito del carrusel
  function initCarouselAddToCartButtons() {
    console.log('🛒 [LOP] Inicializando botones de agregar al carrito del carrusel...');

    bindMobileSizePanel();

    document.addEventListener('change', function(e) {
      const select = e.target.closest && e.target.closest('[data-lop-cart-rec-size]');
      if (!select) return;
      syncCarouselSize(select);
    });
    
    document.addEventListener('click', function(e) {
      const addBtn = e.target.closest('.LOP-cart-drawer--carousel-add-btn');
      if (!addBtn || addBtn.disabled) return;
      if (addBtn.tagName === 'A') return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const productId = addBtn.dataset.productId;
      
      if (!productId) {
        console.error('❌ [LOP] No se encontró ID del producto');
        return;
      }
      
      console.log(`🛒 [LOP] Agregando producto del carrusel: ${productId}`);
      
      const label = addBtn.querySelector('.LOP-cart-drawer--carousel-add-btn-text');
      const originalText = label ? label.textContent : addBtn.textContent;
      addBtn.disabled = true;
      if (label) label.textContent = 'Agregando...';
      else addBtn.textContent = 'Agregando...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('No se pudo agregar');
        return response.json();
      })
      .then(data => {
        console.log('✅ [LOP] Producto agregado desde carrusel:', data);
        const variantId = String(productId);
        document.querySelectorAll('.LOP-cart-drawer--carousel-add-btn').forEach((btn) => {
          if (String(btn.dataset.productId) !== variantId) return;
          const item = btn.closest('.LOP-cart-drawer--carousel-item');
          const section = btn.closest('.LOP-cart-drawer--carousel-section');
          if (item) item.remove();
          if (section && !section.querySelector('.LOP-cart-drawer--carousel-item') && section.dataset.recommendationsMode !== 'true') {
            section.hidden = true;
          }
        });
        return rebuildCartDrawerFromAPI();
      })
      .then(() => {
        // Reinicializar el carrusel después de actualizar el cart drawer
        setTimeout(() => {
          initCartCarousel();
        }, 200);
      })
      .catch(error => {
        console.error('❌ [LOP] Error al agregar producto:', error);
      })
      .finally(() => {
        addBtn.disabled = false;
        const currentLabel = addBtn.querySelector('.LOP-cart-drawer--carousel-add-btn-text');
        if (currentLabel) currentLabel.textContent = originalText;
        else addBtn.textContent = originalText;
      });
    });
  }

  // Función de inicialización principal
  function initialize() {
    console.log('🚀 [LOP] Inicializando cart drawer...');
    
    // Inicializar configuración del tema primero
    initializeThemeSettings();
    harvestCartDiscountBadges();
    
    if (!verifySystem()) {
      console.error('❌ [LOP] Sistema no válido, abortando inicialización');
      return;
    }
    
    initCartDrawer();
    initQuantityButtons();
    initRemoveButtons();
    listenForAddToCartDelegated();
    listenForAddToCartButtons();
    listenForCartItemAdded(); // Escuchar eventos de productos agregados
    initCartCarousel(); // Inicializar carrusel de colección
    initCarouselAddToCartButtons(); // Inicializar botones de agregar al carrito del carrusel
    
    // Agregar funciones adicionales a window.LOP
    window.LOP.rebuildCartDrawerFromAPI = rebuildCartDrawerFromAPI;
    window.LOP.debugQuantitySystem = debugQuantitySystem;
    window.LOP.showErrorMessage = showErrorMessage;
    window.updateCartDrawer = rebuildCartDrawerFromAPI;
    window.LOP.debugEventListeners = debugEventListeners;
    window.LOP.initializeThemeSettings = initializeThemeSettings;
    window.LOP.initCartCarousel = initCartCarousel;
    window.LOP.carouselGoPrev = carouselGoPrev;
    window.LOP.carouselGoNext = carouselGoNext;
    window.LOP.updateCarouselPosition = updateCarouselPosition;
    window.LOP.debugCarousel = function() {
      console.log('=== DEBUG CARRUSEL ===');
      console.log('carouselCurrentIndex:', carouselCurrentIndex);
      console.log('carouselTotalItems:', carouselTotalItems);
      console.log('carouselItemsPerView:', carouselItemsPerView);
      console.log('carouselListenerAdded:', carouselListenerAdded);
      const track = document.querySelector('.LOP-cart-drawer--carousel-track');
      const prevBtn = document.querySelector('.LOP-cart-drawer--carousel-prev');
      const nextBtn = document.querySelector('.LOP-cart-drawer--carousel-next');
      console.log('track:', track);
      console.log('prevBtn:', prevBtn);
      console.log('nextBtn:', nextBtn);
      console.log('prevBtn disabled:', prevBtn?.disabled);
      console.log('nextBtn disabled:', nextBtn?.disabled);
    };
    
    console.log('🎉 [LOP] Cart drawer inicializado correctamente');
    console.log('✅ [LOP] Funciones disponibles globalmente:', Object.keys(window.LOP));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();